import React, { useState, useEffect } from 'react';
import { Menu, X } from 'lucide-react';
import Logo from './Logo';
import { navLinks } from '../mock';

const Navbar = () => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 30);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled
          ? 'bg-[#faf7f0]/90 backdrop-blur-md border-b border-[#c9a961]/25 py-3'
          : 'bg-transparent py-5'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 flex items-center justify-between">
        <a href="#home" className="shrink-0">
          <Logo size={scrolled ? 'sm' : 'md'} />
        </a>

        <nav className="hidden lg:flex items-center gap-8">
          {navLinks.map((l) => (
            <a
              key={l.href}
              href={l.href}
              className="relative text-[12px] tracking-[0.22em] uppercase font-medium text-[#2b2521] hover:text-[#a8842c] transition-colors duration-300 group"
            >
              {l.label}
              <span className="absolute -bottom-1 left-1/2 -translate-x-1/2 w-0 h-px bg-[#c9a961] group-hover:w-full transition-all duration-500" />
            </a>
          ))}
        </nav>

        <a href="#reading" className="hidden lg:inline-flex btn-gold whitespace-nowrap">Book a Reading · ₹1000</a>

        <button
          aria-label="Toggle menu"
          className="lg:hidden text-[#1a1714] p-2"
          onClick={() => setOpen(!open)}
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {/* Mobile menu */}
      <div
        className={`lg:hidden overflow-hidden transition-all duration-500 ${
          open ? 'max-h-[600px] mt-4' : 'max-h-0'
        }`}
      >
        <div className="px-6 pb-6 flex flex-col gap-4 bg-[#faf7f0]/95 backdrop-blur">
          {navLinks.map((l) => (
            <a
              key={l.href}
              href={l.href}
              onClick={() => setOpen(false)}
              className="text-sm tracking-[0.22em] uppercase font-medium text-[#2b2521] py-2 border-b border-[#c9a961]/20"
            >
              {l.label}
            </a>
          ))}
          <a href="#reading" onClick={() => setOpen(false)} className="btn-gold mt-2 self-start">
            Book a Reading · ₹1000
          </a>
        </div>
      </div>
    </header>
  );
};

export default Navbar;
